import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import DateFnsUtils from "@date-io/date-fns";
import { enUS, ptBR, es as esLocale } from "date-fns/locale";
import { ThemeProvider as MuiThemeProvider} from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { StylesProvider } from "@material-ui/styles";
import { ThemeProvider } from "styled-components";
import moment from "moment";

import maTheme from "./theme";
import Routes from "./routes/Routes";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfirmProvider } from 'material-ui-confirm';
import {SnackbarProvider} from "notistack";

// Map i18next language codes to date-fns locale objects
const DATE_FNS_LOCALES = {
  en: enUS,
  es: esLocale,
  pt: ptBR,
};

// Map i18next language codes to moment locale strings
const MOMENT_LOCALES = {
  en: 'en',
  es: 'es',
  pt: 'pt-br',
};

const App = ({ theme }) => {
  const { i18n } = useTranslation();
  const activeLanguage = i18n.language?.split('-')[0] || 'en';
  const dateFnsLocale = DATE_FNS_LOCALES[activeLanguage] || enUS;

  // Sync moment locale whenever the active i18n language changes
  useEffect(() => {
    const momentLocale = MOMENT_LOCALES[activeLanguage] || 'en';
    moment.locale(momentLocale);
  }, [activeLanguage]);

  return (
    <StylesProvider injectFirst>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateFnsLocale}>
        <MuiThemeProvider theme={maTheme[theme.currentTheme]}>
          <ThemeProvider theme={maTheme[theme.currentTheme]}>
            <ConfirmProvider>
             <SnackbarProvider maxSnack={1}>
              <Routes />
             </SnackbarProvider>
            </ConfirmProvider>
          </ThemeProvider>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    </StylesProvider>
  )
}
const ConnectedApp = connect(store => ({ theme: store.themeReducer }))(App);

function AppWithRouter() {
  return (
    <Router>
      <ConnectedApp/>
    </Router>
  );
}

export default AppWithRouter;
